// Prime pieces (12 §12.5): documents and parcels have no pre-printed barcode. Each piece gets a
// label made from the tracking number: `{trackingNo}-P1`, `-P2`, … Pure string work. Any tracking
// number works (03 §3.5: every series, and numbers typed by hand), because no tracking number may
// itself end like `-P1`.
import { isTrackingNo } from './tracking-series';

const PIECE_PATTERN = /^([A-Z0-9][A-Z0-9-]*[A-Z0-9])-P(\d{1,2})$/;
const BOX_PATTERN = /^EB\d{10}$/;

/** The size code Prime pieces are priced under: no box size, so rate rows can match on weight alone. */
export const PIECE_SIZE_ID = 'PIECE';

/** The most pieces one shipment can carry: the label has one or two digits. */
export const MAX_PIECES_PER_SHIPMENT = 50;

export function pieceId(trackingNo: string, n: number): string {
  if (!isTrackingNo(trackingNo)) {
    throw new Error(`"${trackingNo}" is not a tracking number`);
  }
  if (!Number.isInteger(n) || n < 1 || n > MAX_PIECES_PER_SHIPMENT) {
    throw new Error(`Piece number must be 1 to ${MAX_PIECES_PER_SHIPMENT}, got ${n}`);
  }
  return `${trackingNo}-P${n}`;
}

export function parsePieceId(value: string): { trackingNo: string; n: number } | undefined {
  const m = PIECE_PATTERN.exec(value);
  if (!m) return undefined;
  const trackingNo = m[1] as string;
  const n = Number(m[2]);
  return isTrackingNo(trackingNo) && n >= 1 && n <= MAX_PIECES_PER_SHIPMENT
    ? { trackingNo, n }
    : undefined;
}

export function isPieceId(value: string): boolean {
  return parsePieceId(value) !== undefined;
}

/** A box barcode or a piece label: anything a partner can carry. */
export function isUnitId(value: string): boolean {
  return BOX_PATTERN.test(value) || isPieceId(value);
}

/** The labels for `count` pieces of a shipment, `-P1` to `-P{count}`. */
export function pieceIds(trackingNo: string, count: number): string[] {
  return Array.from({ length: count }, (_, i) => pieceId(trackingNo, i + 1));
}
